import { AxiosResponse } from 'axios';
import { ROLES } from './roles';
import { formatFileSize } from './file';

export function formatFileInfo(file: AxiosResponse<File, any>): string {
  const headers = file.headers;

  const contentLength = Number(headers['content-length']);
  const contentType = headers['content-type'];

  const size = contentLength ? formatFileSize(contentLength) : '';

  const fileExtension = ROLES.RESOURCE.FILE_EXTENSION(contentType);

  return `${fileExtension} • ${size}`;
}
